import type { ChartConfig } from "@/ds/shadcn/components/ui/chart";

export const getEvHistoricalPricingChartConfig = (): ChartConfig => {
	return {
		estimatedValue: {
			label: "Estimated Value",
			color: "#5AAA3E"
		},
		marketPrice: {
			label: "Market Price",
			color: "#3E90AA"
		}
	};
};
